import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ProductService, Product } from 'gung-standard';
import { FilterListComponent } from 'gung-list';
import { ColmecRimListByIdsConfigService } from '../../../services/colmec-rim-list-by-ids-config.service';

@Component({
    selector: 'colmec-rim-list-by-ids',
    template: '<lib-filter-list #productList [configService]="configService"></lib-filter-list>',
    styleUrls: ['./colmec-rim-list-by-ids.component.scss'],
    standalone: false
})
export class ColmecRimListByIdsComponent implements OnInit {
  @Input()
  private productIds: string[];

  @Input()
  private parentProductId: string;

  @ViewChild('productList') productList: FilterListComponent<Product>;

  constructor(public configService: ColmecRimListByIdsConfigService, protected productService: ProductService) {}

  ngOnInit() {
    this.configService.setParentProductId(this.parentProductId);
    this.configService.setSubscriptionIds(this.productIds);
  }
}
